import React from 'react'

export const createContextFactory = <T extends unknown>(defaultValue: T) => React.createContext<T>(defaultValue)
